import AxiosInterceptorAlcohol from '../../AxiosInterceptorAlcohol';

export default function getSystemMessageFromAlcohol() {
	return AxiosInterceptorAlcohol({ url: '/system-message', method: 'get', timeout: 5000 });
}
